var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "no-ssr",
    [
      _c(
        "transition",
        {
          attrs: {
            categoryProps: _vm.categoryProps,
            name:
              _vm.direction === "right"
                ? "slide-left"
                : _vm.direction === "left"
                ? "slide-right"
                : null
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen"
                }
              ],
              ref: "sidebar",
              staticClass: "mw-100 fixed cl-accent bg-cl-primary",
              class:
                _vm.direction === "left"
                  ? "left-sidebar"
                  : _vm.direction === "right"
                  ? "right-sidebar"
                  : null,
              attrs: {
                categoryProps: _vm.categoryProps,
                "data-testid": "sidebar"
              }
            },
            [
              _c(_vm.component, {
                tag: "component",
                attrs: { categoryProps: _vm.categoryProps },
                on: {
                  close: function($event) {
                    return _vm.$emit("close")
                  },
                  reload: _vm.getComponent
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }